import useReactRouter from 'use-react-router';

export const useYear = () => {
  const {
    match: { params }
  } = useReactRouter();
  let year = params.year && params.year | 0;
  return year;
};
